import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  selectedType: null,
  CanBeEditSurvey: true,
  title: null,
  singleSurvey: {}
};

const supplementriesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_SURVEYS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta
      };
    case types.GET_SINGLE_SURVEY_STATISTCS_RESPONSE:
      return {
        ...state,
        singleSurveyStatistics: action.payload.survey
      };
    case types.SET_SURVEY_FILTERS:
      return {
        ...state,
        title: action.payload.title
      };
    case types.GET_SINGLE_SURVEY_RESPONSE:
      return { ...state, singleSurvey: action.payload };
    case types.CHECK_FOR_CAN_BE_EDIT_SURVEY_RESPONSE:
      return { ...state, CanBeEditSurvey: action.payload };
    default:
      return state;
  }
};

export default supplementriesReducer;
